import { API_ENDPOINTS } from "../../../Api/apiEndPoints"
import axiosInstance from "../../../Api/axiosInstance";




export const  getBrandList = async(params={})=>{
    let response = await axiosInstance.get(API_ENDPOINTS.Brnad.GET_Brand_LIST,{params:params});
    return response?.data;
} 

interface reqBody{
    BrandName: string,
    BrandCode: string,
    BrandRate: number,
    MinValue: number,
    Orgunitid: number | null
}
export const addBrand = async({ReqBody}:{ReqBody:reqBody})=>{
    const url = `${API_ENDPOINTS.Brnad.POST_ADD_BRAND}` ;  
    let response = await axiosInstance.post(url,ReqBody);
} 


export const updateBrand = async ({id, ReqBody,}: {ReqBody: any;id: number}) => {
    const url = `${API_ENDPOINTS.Brnad.POST_UPDATE_BRAND}/${id}`;
    const response = await axiosInstance.put(url, ReqBody);
    return response.data; // 
  };
  